import React from "react";
import { Redirect, withRouter } from "react-router-dom";
import { DetailClientsPoliciesContainer } from "./detail-clients-policies-style";
import MainTable from "../../../../components/main-table";
import GoBack from "../../../../components/go-back";
import { withGeneral } from "../../../../context/mixin/with-general";
import PoliciesServices from "../../../../services/PoliciesServices";
import MainButton from "../../../../components/main-button";
import { ErrorModalContainer } from "../../../../components/error-modal/error-modal-style";
import { convertBase64ToFile, deepGet, downloadFile, formatter } from "../../../../utils/utility";
import { petDataColumns, personDataColumns, receiptDataColumns, tarjetasDataColumns, POLICY_SEARCH_OPTION } from "../../../../constants/clientsPolicies";
import Pagination from "../../../../components/pagination";
import {
  DetailClientsPoliciesProps, DetailClientsPoliciesState, IPolicyDataRow, IPolicyReceiptDataRow, IPolicyRiskDataRow,
  IPolicyTakerDataRow, ITableConfig, PolicyDetailDataDto, TakerDetailDataDto, ReceiptDetailDataDto, RiskDetailPersonDataDto, RiskDetailPetDataDto,
  ITarjetasDataRow
} from "../dto/detail-clients-policies-layout-dto";
import { ERROR_MESSAGES } from "../../../../constants/errorMessages";
import { IPolicyDetail, IPolicyReceiptsDetail, IPolicyRiskDetail, IPolicyTakerDetail } from "../../../../services/PoliciesServices-dto";
import GestDocServices from "../../../../services/Gest-Doc.Services";
import { Button, SimpleButton } from "../../../../components/buttons";
import { getUserCode } from "../../../../utils/mediatorCode";
import { withDynamicProducts } from "../../../../context/mixin/with-dynamic-products";
import dateFns from 'date-fns';
import { PrivilegeCode } from "../../../../services/PrivilegesServices-dto";
import { getPrivilege } from "../../../../utils/privileges";
import Alert from "../../../../components/alert/alert";
import { images } from "../../../../assets";
import webedaServices from "../../../../services/webedaServices";
import ModalTarjetas from "../modals/modal-tarjeta";
import WPStatusModal from "../modals/wp-status-modal";


const STATUS = {
  VIGENTE: "VIGENTE",
  BAJA: "BAJA",
};

class DetailClientsPoliciesLayout extends React.Component<DetailClientsPoliciesProps, DetailClientsPoliciesState> {
  constructor(props: DetailClientsPoliciesProps) {
    super(props);
    this.state = {
      policyDataRows: [],
      policyData: [],
      takerDataRows: [],
      personDataRows: [],
      petDataRows: [],
      receiptDataRows: [],
      tarjetasDataRows: [],
      mediatorCode: props.match.params.mediator,
      policy: props.match.params.id,
      nifTomador: '',
      searchType: POLICY_SEARCH_OPTION.POLIZA,
      colective: '',
      codRamo: '',
      subramo: '',
      text: '',
      idDelete: undefined,
      currentTab: 'datos-poliza',
      riskParams: {
        order: '',
        ascendent: false,
        page: 1,
        showItems: 6,
        totalPages: 0,
      },
      receiptsParams: {
        order: 'fec_expedicion',
        ascendent: false,
        page: 1,
        showItems: 6,
        totalPages: 0,
      },
      serverError: false,
      forbidden: (!props.location.state ? true : false),
      policyOrigin: '',
      noDataMessage: '',
      showPrima: false,
      primaError: "",
      wpSignedStatus: '',
      wpSignedError: false,
      mostrarModalTarjeta: false,
      datosTarjeta: {},
      wpStatus: [],
      wpError: false,
      isWPStatusModalVisible: false,
    };
  }

  componentDidMount() {
    this.tryGetNavigationProps();
    if (!this.state.forbidden && !this.state.serverError)
      this.getPolicy();
  }

  tryGetNavigationProps = () => {
    if (this.props.location.state) {
      try {
        this.setState({
          colective: this.props.location.state.data.colectivo.text.substr(0, this.props.location.state.data.colectivo.text.indexOf('|')),
          subramo: this.props.location.state.data.colectivo.text.substr(this.props.location.state.data.colectivo.text.indexOf('|') + 1),
          nifTomador: this.props.location.state.data.nif_tomador.text,
        });
      } catch {
        this.setState({
          serverError: true,
        });
      }
    }
  }

  getPolicy = async (newSearch?: boolean) => {
    if (!newSearch && this.state.policyDataRows.length > 0) return;

    const { policy, mediatorCode } = this.state;


    const { setLoading } = this.props;

    const data: IPolicyDetail = {
      codMediador: mediatorCode,
      policy: policy,
    }

    const detailPolicy = await PoliciesServices.searchPolicyDetail(
      setLoading,
      true,
      data,
    ).catch(() => {
      this.setState({ serverError: true });
    });

    if (detailPolicy !== undefined) {
      let showPrima = false;
      const codRamo = detailPolicy.policyDetail[0].cod_ramo;
      const subramo = detailPolicy.policyDetail[0].subramo;
      const origenPoliza = detailPolicy.policyDetail[0].origen_poliza;
      const grupoNegocio = detailPolicy.policyDetail[0].grupo_negocio;

      if (subramo === "ASISA SALUD" && origenPoliza === "SENDA" && grupoNegocio === "Particulares") {
        showPrima = true;
      }
      await this.getTaker();
      //Consoltamos el estado de firma del WP
      if (this.state.nifTomador) {
        let wpdata = {
          NifTomador: this.state.nifTomador,
          NumPoliza: data.policy
        }

        const WPSignStatus = await webedaServices.getWPSignStatus(
          setLoading,
          true,
          wpdata
        ).catch(() => {

        });
        if (WPSignStatus.error !== '') {
          this.setState({ wpSignedStatus: WPSignStatus.error, wpSignedError: true })

        } else {
          this.setState({ wpSignedStatus: WPSignStatus.firmado ? 'Firmado' : 'No firmado', wpSignedError: false })
        }
      }

      //Consulta estado WP
      let wpStatusRequestData = {
        NumPoliza: data.policy,
        ...( (this.state.nifTomador && this.state.nifTomador !== 'undefined') && {NifTomador: this.state.nifTomador })
      }

      const WPStatus = await webedaServices.getWPStatus(
        setLoading,
        true,
        wpStatusRequestData
      )
      
      if(!!WPStatus){
        this.setState({ wpStatus: WPStatus, wpError: false})
      }else{
        this.setState({wpStatus: [], wpError: true})
      }

      const policyDataRows: IPolicyDataRow[] = [];
      detailPolicy.policyDetail.forEach((policy: PolicyDetailDataDto) => {
        const row: IPolicyDataRow = {
          policySubramo: {
            text: policy.subramo,
            type: "",
            link: "",
            key: "responsive",
          },
          policyGrupoNegocio: {
            text: policy.grupo_negocio,
            type: "",
            link: "",
            key: "responsive",
          },
          policyColective: {
            text: policy.colectivo,
            type: "",
            link: "",
            key: "responsive number",
          },
          policyMediator: {
            text: mediatorCode,
            type: "",
            link: "",
            key: "responsive number",
          },
          policyNumber: {
            text: policy.poliza,
            type: "",
            link: "",
            key: "responsive number",
          },
          status: {
            text: policy.estado_poliza,
            type: "",
            link: "",
            key: "responsive",
          },
          order: {
            text: policy.orden,
            type: "",
            link: "",
            key: "responsive",
          },
          policyReleaseDate: {
            text: policy.fec_emision ? new Date(policy.fec_emision).toLocaleDateString() : "",
            type: "",
            link: "",
            key: "responsive number",
          },
          policyInitialDate: {
            text: policy.fec_efecto_alta ? new Date(policy.fec_efecto_alta).toLocaleDateString() : "",
            type: "",
            link: "",
            key: "responsive number",
          },
          policyFinishDate: {
            text: policy.fec_vencimiento ? new Date(policy.fec_vencimiento).toLocaleDateString() : "",
            type: "",
            link: "",
            key: "responsive number",
          },
          policyPaymentForm: {
            text: policy.pago_fraccionado,
            type: "",
            link: "",
            key: "responsive",
          },
          controlid: {
            text: (policy.controlid) ? policy.controlid : '',
            type: "",
            link: "",
            key: "responsive number",
          },
          codPolizaUni: {
            text: (policy.cod_poliza_uni) ? policy.cod_poliza_uni : '',
            type: "",
            link: "",
            key: "responsive number",
          },
          codPoliza: {
            text: (policy.cod_poliza) ? policy.cod_poliza : '',
            type: "",
            link: "",
            key: "responsive number",
          },
          policyPrimaTotalAnualizada: {
            text: policy.prima_total_anualizada? formatter.format(Number(policy.prima_total_anualizada)) : "",
            type: "",
            link: "",
            key: "responsive number",
          }
        }
        if (showPrima && policy.primaTotal) {
          row.policyPrimaTotal = {
            text: formatter.format(Number(policy.primaTotal)),
            type: "",
            link: "",
            key: "responsive number",
          }
        } else {
          showPrima = false;
        }
        policyDataRows.push(row);
      });

      const isPetPolicy = detailPolicy.policyDetail[0].subramo.toLocaleLowerCase().includes("mascotas");
      const primaError = detailPolicy.policyDetail[0].errorPrimasAsegurados;
      this.setState({
        policyDataRows,
        policyOrigin: deepGet(detailPolicy, 'policyDetail[0].origen_poliza') ? detailPolicy.policyDetail[0].origen_poliza : '',
        policyData: detailPolicy.policyDetail,
        riskParams: { ...this.state.riskParams, order: isPetPolicy ? "nom_mascota" : "nom_asegurado" },
        showPrima,
        codRamo,
        ...(primaError && primaError.errorMessage ? { primaError: `${primaError.errorMessage}. Por favor, reintente` } : { primaError: "" }),
      });
    }
  }

  getPolicyDocuments = async () => {
    const { policyOrigin, policyDataRows } = this.state;
    // if (policyOrigin === 'SENDA' && policyDataRows[0].policySubramo.text === 'ASISA SALUD' ) await this.downloadPolicyDocumentsFromGestDoc();
    // else {
    let documentPolicy: any;
    // if (policyOrigin === 'SENDA') documentPolicy = await this.getDocumentFromSenda();
    // else 
    if (policyOrigin === 'GIP') {
      const response = await this.getDocumentFromCmod()
      documentPolicy = response.document
    }
    else documentPolicy = await this.getDocumentFromSenda();

    if (documentPolicy !== undefined && documentPolicy.length > 0) {
      const type = 'application/pdf';
      const file_object = convertBase64ToFile(documentPolicy, type);
      const fileURL = URL.createObjectURL(file_object);
      window.open(fileURL);
    }
    else this.setState({ serverError: true });
    // }
  }

  async downloadPolicyDocumentsFromGestDoc() {
    try {
      const { policy } = this.state;
      const queryParticularConditions = {
        "SITE": "clientes",
        "ins2:documentType": "Condiciones Particulares",
        "ins2:policyId": policy
      };
      const file = await GestDocServices.searchAndGetLastFile(this.props.setLoading, true, { fileInfo: queryParticularConditions });

      if (file && file.fileData && file.fileName && file.fileType) downloadFile(file.fileData, file.fileName, file.fileType, true);
      else this.setState({ serverError: true });

    } catch (error) {
      this.setState({ serverError: true });
    }
  }

  downloadRenewalLetter = async () => {
    const { policy } = this.state;
    const queryRenewalLetter = {
      "SITE":"clientes",
      "ins2:documentType": "Carta de Renovación",
      "ins2:policyId": policy
    };

    try {
      const file = await GestDocServices.getLastFileByDate(
        this.props.setLoading,
        true,
        { fileInfo: queryRenewalLetter }
      );

      if (file && file.fileData && file.fileName && file.fileType) {
        downloadFile(file.fileData, file.fileName, file.fileType, true);
      } else {
        this.setState({ serverError: true });
      }
    } catch (error) {
      this.setState({ serverError: true })
    }
  };

  getDocumentFromSenda = async () => {
    const { policyDataRows, policyData } = this.state;
    const { setLoading } = this.props;
    
    const data = {
      businessLine: policyDataRows[0].policySubramo.text,
      requestNumber: policyDataRows[0].policyNumber.text,
      effectDate: policyDataRows[0].policyInitialDate.text,
    }

    return await PoliciesServices.getPolicyDocuments({
      loader: true,
      setLoading: setLoading,
      data: data,
      url: 'documents/documentSenda'
    }).catch(() => {
      this.setState({ serverError: true });
    });
  }

  getDocumentFromCmod = async () => {
    const { policyDataRows } = this.state;
    const { setLoading } = this.props;
    const data = policyDataRows.map(policyDataRow => ({
      policyId: policyDataRow.policyNumber.text,
      order: policyDataRow.order.text,
      controlId: policyDataRow.controlid.text,
      codPoliza: policyDataRow.codPoliza.text,
    }))
    try {
      const respuesta = await PoliciesServices.getPolicyDocuments({
        loader: true,
        setLoading: setLoading,
        data: data,
        url: 'Cmod/document'
      })
      return respuesta;

    } catch (e) {
      this.setState({ serverError: true });
    };
  }

  getTaker = async () => {
    if (this.state.takerDataRows.length > 0) return;

    const { nifTomador, mediatorCode } = this.state;
    const { setLoading } = this.props;

    const data: IPolicyTakerDetail = {
      codMediador: mediatorCode,
      nifTomador: nifTomador,
    }

    const takerDetail = await PoliciesServices.searchTakerDetail(
      setLoading,
      true,
      data,
    ).catch(() => {
      this.setState({ serverError: true });
    });

    if (takerDetail !== undefined) {
      const takerDataRows: IPolicyTakerDataRow[] = [];
      takerDetail.takerDetail.forEach((taker: TakerDetailDataDto) => {
        const municipio = taker.municipio_tomador != taker.poblacion_tomador ? taker.municipio_tomador : null;
        const taker_direction = [taker.direccion_tomador, taker.codigo_postal_tomador, taker.poblacion_tomador, municipio, taker.provincia_tomador, taker.pais_tomador].filter(Boolean).join(' ');
        const row: IPolicyTakerDataRow = {
          policyNIF: {
            text: taker.nif_tomador,
            type: "",
            link: "",
            key: "responsive number",
          },
          birth_date: {
            text: taker.fec_nacimiento_tomador ? new Date(taker.fec_nacimiento_tomador).toLocaleDateString() : "",
            type: "",
            link: "",
            key: "responsive number",
          },
          genre: {
            text: taker.sexo,
            type: "",
            link: "",
            key: "responsive",
          },
          civil_state: {
            text: taker.des_estado_civil,
            type: "",
            link: "",
            key: "responsive",
          },
          direction: {
            text: taker_direction,
            type: "",
            link: "",
            key: "responsive",
          },
          phone: {
            text: taker.telefono,
            type: "",
            link: "",
            key: "responsive number",
          },
          mail: {
            text: taker.email,
            type: "",
            link: "",
            key: "responsive",
          },
          takerName: {
            text: taker.nom_tomador,
            type: "",
            link: "",
            key: "responsive",
          }
        }
        takerDataRows.push(row);
      });

      this.setState({ takerDataRows: takerDataRows });
    }
  }

  getRisk = async (newSearch?: boolean) => {
    const { policy, searchType, policyDataRows, riskParams, mediatorCode, policyData, showPrima } = this.state;
    const { setLoading } = this.props;

    if (!newSearch && this.state.personDataRows.length > 0) return;

    const queryParams = [
      `skip=${riskParams.showItems * (riskParams.page - 1)}`,
      `take=${riskParams.showItems}`,
      `order=${riskParams.ascendent ? '' : '-'}${riskParams.order}`
    ];

    const data: IPolicyRiskDetail = {
      subramo: policyDataRows[0].policySubramo.text,
      codMediador: mediatorCode,
      searchType: searchType,
      data: policy,
    }

    const riskDetail = await PoliciesServices.searchRiskDetail(
      setLoading,
      true,
      queryParams,
      data,
    ).catch(() => {
      this.setState({ serverError: true });
    });

    if (riskDetail !== undefined && riskDetail.count !== 0) {
      const primasAsegurados = policyData[0].primasAsegurados || [];
      if (riskDetail.riskDetail.personList) {
        const personDataRows: IPolicyRiskDataRow[] = [];
        riskDetail.riskDetail.personList.forEach((person: RiskDetailPersonDataDto) => {
          const municipio = person.municipio != person.poblacion ? person.municipio : null;
          const person_direction = [person.direccion, person.codigo_postal, person.poblacion, municipio, person.provincia, person.pais].filter(Boolean).join(' ');
          const row: IPolicyRiskDataRow = {
            fec_efecto_alta: {
              text: person.fec_efecto_alta ? new Date(person.fec_efecto_alta).toLocaleDateString() : "",
              type: "",
              link: "",
              key: "responsive number",
            },
            fec_efecto_baja: {
              text: person.fec_efecto_baja ? new Date(person.fec_efecto_baja).toLocaleDateString() : "",
              type: "",
              link: "",
              key: "responsive number",
            },
            nom_asegurado: {
              text: person.nom_asegurado,
              type: "",
              link: "",
              key: "responsive",
            },
            nif_asegurado: {
              text: person.nif_asegurado,
              type: "",
              link: "",
              key: "responsive number",
            },
            fec_nacimiento: {
              text: person.fec_nacimiento ? new Date(person.fec_nacimiento).toLocaleDateString() : "",
              type: "",
              link: "",
              key: "responsive number",
            },
            sexo: {
              text: person.sexo,
              type: "",
              link: "",
              key: "responsive",
            },
            direccion: {
              text: person_direction,
              type: "",
              link: "",
              key: "responsive",
            },
            prima_anualizada: {
                text: person.prima_total_anualizada ?formatter.format(Number(person.prima_total_anualizada)) : "-",
                type: "",
                link: "",
                key: "responsive",
            }
          }

          if (showPrima) {
            const prima = primasAsegurados.find((item) => item.nif_asegurado === person.nif_asegurado);
            if (prima && prima.primaTotal) {
              row.prima = {
                text: formatter.format(Number(prima.primaTotal)),
                type: "",
                link: "",
                key: "responsive",
              }
            }
          }
          personDataRows.push(row);
        });

        const pages = Math.ceil(riskDetail.count / riskParams.showItems);
        riskParams.totalPages = pages;
        this.setState({ personDataRows: personDataRows, riskParams });
      }

      if (riskDetail.riskDetail.petList) {
        const petDataRows: any[] = [];
        riskDetail.riskDetail.petList.forEach((pet: RiskDetailPetDataDto) => {
          const row = {
            fec_efecto_alta: {
              text: pet.fec_efecto_alta ? new Date(pet.fec_efecto_alta).toLocaleDateString() : "",
              type: "",
              link: "",
              key: "responsive number",
            },
            fec_efecto_baja: {
              text: pet.fec_efecto_baja ? new Date(pet.fec_efecto_baja).toLocaleDateString() : "",
              type: "",
              link: "",
              key: "responsive number",
            },
            nom_mascota: {
              text: pet.nom_mascota,
              type: "",
              link: "",
              key: "responsive",
            },
            nom_propietario: {
              text: pet.nom_propietario,
              type: "",
              link: "",
              key: "responsive",
            },
            chip: {
              text: pet.chip,
              type: "",
              link: "",
              key: "responsive number",
            },
            fec_nacimiento: {
              text: pet.fec_nacimiento ? new Date(pet.fec_nacimiento).toLocaleDateString() : "",
              type: "",
              link: "",
              key: "responsive number",
            },
            tipo_mascota: {
              text: pet.tipo_mascota,
              type: "",
              link: "",
              key: "responsive",
            },
            prima_anualizada: {
                text: pet.prima_total_anualizada ?formatter.format(Number(pet.prima_total_anualizada)) : "-",
                type: "",
                link: "",
                key: "responsive",
            }
          }
          petDataRows.push(row);
        });

        const pages = Math.ceil(riskDetail.count / riskParams.showItems);
        riskParams.totalPages = pages;
        this.setState({ petDataRows: petDataRows, riskParams });
      }
    }
    else {
      if (this.state.serverError !== true) {
        this.setState({ noDataMessage: ERROR_MESSAGES["no-data"] });
      }
    }
  }
  getTarjetas = async () => {
    const { policy, personDataRows } = this.state;
    const { setLoading } = this.props;
    const tarjetasDataRows: ITarjetasDataRow[] = [];

    for (let i = 0; i < personDataRows.length; i++) {
      let wpdata = {
        NifAsegurado: personDataRows[i].nif_asegurado.text,
        NumPoliza: policy
      }
      const resultTarjeta = await webedaServices.getConsultaTarjetas(
        setLoading,
        true,
        wpdata
      ).catch(() => {

      });
      const row: ITarjetasDataRow = {
        nif: {
          text: personDataRows[i].nif_asegurado.text ? personDataRows[i].nif_asegurado.text : '-',
          type: "",
          link: "",
          key: "responsive number",
        },
        titular: {
          text: resultTarjeta.Titular ? resultTarjeta.Titular : "-",
          type: "",
          link: "",
          key: "responsive",
        },
        // numero_tarjeta: {
        //   text: resultTarjeta.Numero ? resultTarjeta.Numero : "-",
        //   type: "",
        //   link: "",
        //   key: "responsive",
        // },
        version: {
          text: resultTarjeta.Version ? resultTarjeta.Version : "-",
          type: "",
          link: "",
          key: "responsive number",
        },
        fec_efecto: {
          text: resultTarjeta.FechaEfecto ? resultTarjeta.FechaEfecto : "-",
          type: "",
          link: "",
          key: "responsive number",
        },
        fec_caducidad: {
          text: resultTarjeta.FechaCaducidad ? resultTarjeta.FechaCaducidad : "-",
          type: "",
          link: "",
          key: "responsive number",
        },
        estado: {
          text: resultTarjeta.Estado ? resultTarjeta.Estado : "-",
          type: "",
          link: "",
          key: "responsive number",
        },
        action: {
          key: "button",
          text: "Ver",
          onClick: () => this.setState({ mostrarModalTarjeta: true, datosTarjeta: resultTarjeta }),
          toolTips: "Detalles de tarjeta"
        },
      }
      tarjetasDataRows.push(row);

    }
    this.setState({ tarjetasDataRows: tarjetasDataRows });

  }
  getReceipts = async (newSearch: boolean) => {
    let { policy, colective, receiptsParams, mediatorCode } = this.state;
    const { setLoading } = this.props;

    if (newSearch) {
      this.setState({ receiptDataRows: [] });
      receiptsParams = {
        order: 'fec_expedicion',
        ascendent: false,
        page: 1,
        showItems: 6,
        totalPages: 0,
      }
    }

    const queryParams = [
      `skip=${receiptsParams.showItems * (receiptsParams.page - 1)}`,
      `take=${receiptsParams.showItems}`,
    ];

    if (receiptsParams.order) {
      queryParams.push(`order=${receiptsParams.ascendent ? '' : '-'}${receiptsParams.order}`);
    }

    const data: IPolicyReceiptsDetail = {
      codMediador: mediatorCode,
      colectivo: colective,
      poliza: policy,
    }

    const resReceipts = await PoliciesServices.searchReceiptDetail(
      setLoading,
      true,
      queryParams,
      data,
    ).catch(() => {
      this.setState({ serverError: true });
    });

    if (resReceipts !== undefined && resReceipts.count !== 0) {
      const receiptDataRows: IPolicyReceiptDataRow[] = [];
      resReceipts.receiptDetail.forEach((receipt: ReceiptDetailDataDto) => {
        const row: IPolicyReceiptDataRow = {
          numero_recibo: {
            text: receipt.numero_recibo,
            type: "",
            link: "",
            key: "responsive number",
          },
          estado_recibo: {
            text: receipt.estado_recibo,
            type: "",
            link: "",
            key: "responsive",
          },
          colectivo: {
            text: receipt.colectivo,
            type: "",
            link: "",
            key: "responsive",
          },
          fec_vencimiento_poliza: {
            text: receipt.fec_cobertur_hasta ? new Date(receipt.fec_cobertur_hasta).toLocaleDateString() : "",
            type: "",
            link: "",
            key: "responsive number",
          },
          fec_expedicion: {
            text: receipt.fec_expedicion ? new Date(receipt.fec_expedicion).toLocaleDateString() : "",
            type: "",
            link: "",
            key: "responsive number",
          },
          fec_cobertur_desde: {
            text: receipt.fec_cobertur_desde ? new Date(receipt.fec_cobertur_desde).toLocaleDateString() : "",
            type: "",
            link: "",
            key: "responsive number",
          },
          fec_cobertur_hasta: {
            text: receipt.fec_cobertur_hasta ? new Date(receipt.fec_cobertur_hasta).toLocaleDateString() : "",
            type: "",
            link: "",
            key: "responsive number",
          },
          imp_importe_total: {
            text: (receipt.imp_importe_total.length > 0 ? formatter.format(Number(receipt.imp_importe_total)) : ''),
            type: "",
            link: "",
            key: "responsive",
          },
        }
        receiptDataRows.push(row);
      });

      const pages = Math.ceil(resReceipts.count / receiptsParams.showItems);
      receiptsParams.totalPages = pages;
      this.setState({ receiptDataRows: receiptDataRows, receiptsParams });
    }
    else {
      if (this.state.serverError !== true) {
        this.setState({ noDataMessage: ERROR_MESSAGES["no-data"] });
      }
    }
  }

  generateSuplements = async () => {
    await this.getTaker();
    const { colective, policyDataRows, takerDataRows, policyOrigin, codRamo, policyData: policyInfo } = this.state;
    const { allProducts = [] } = this.props;
    const petitionary = getUserCode();
    const effectDate: string = policyDataRows.length > 0 && policyDataRows[0].policyInitialDate.text ? policyDataRows[0].policyInitialDate.text : '';
    const effectDateFormated = dateFns.format('', "DD/MM/YYYY", { locale: 'es' });
    const endDate: string = policyDataRows.length > 0 && policyDataRows[0].policyFinishDate.text ? policyDataRows[0].policyFinishDate.text : '';
    const endDateFormated = dateFns.format('', "DD/MM/YYYY", { locale: 'es' })
    const completeProduct = deepGet(this.props, 'location.state.data.colectivo.text', '') || ''; // EJ: '24300|PARTICULARES'
    const completProductArray = completeProduct.split('|');
    const productId = policyInfo.length > 0 ? policyInfo[0].cod_producto : "";
    const product = Object.values(allProducts).find((prod) => {
      return prod.products_combinacion_comercial === productId && prod.products_colectivo === colective;
    });
    const policyData = {
      idPeticionario: petitionary,
      takerEmail: takerDataRows.length > 0 && takerDataRows[0].mail.text ? takerDataRows[0].mail.text : '',
      numeroColectivo: colective,
      subramo: policyDataRows.length > 0 && policyDataRows[0].policySubramo.text ? policyDataRows[0].policySubramo.text : '',
      producto: completProductArray.length === 2 ? completProductArray[1] : '',
      tomador: takerDataRows.length > 0 && takerDataRows[0].takerName.text ? takerDataRows[0].takerName.text : '',
      numeroPoliza: policyDataRows.length > 0 && policyDataRows[0].policyNumber.text ? policyDataRows[0].policyNumber.text : '',
      fechaEfecto: effectDateFormated !== 'Invalid Date' ? effectDateFormated : effectDate,
      fechaVencimiento: endDateFormated !== 'Invalid Date' ? endDateFormated : endDate,
      policyOrigin,
      nifTomador: this.state.nifTomador,
      order: policyDataRows.length > 0 && policyDataRows[0].order.text ? policyDataRows[0].order.text : '',
      paymentType: policyDataRows.length > 0 && policyDataRows[0].policyPaymentForm.text ? policyDataRows[0].policyPaymentForm.text : '',
      mediator: this.props.match.params.mediator,
      grupo_negocio: policyDataRows.length > 0 && deepGet(policyDataRows[0], 'policyGrupoNegocio.text', ''),
      productId,
      productName: product ? product.products_name : "",
    }
    localStorage.setItem('policyCodRamo', codRamo);
    localStorage.setItem('policySubramo', policyDataRows.length > 0 && policyDataRows[0].policySubramo.text ? policyDataRows[0].policySubramo.text : '');
    localStorage.setItem('policyData', JSON.stringify(policyData));
    localStorage.setItem('policyOrigin', policyOrigin);
    this.props.history.push(`/suplementos/${this.state.policy}`);
  }

  render() {
    const { forbidden, serverError, currentTab, colective, policyOrigin } = this.state;
    const { allProducts, user } = this.props;

    const privilegeBtnSuplemento = getPrivilege(user, PrivilegeCode.BTN_SUPLEMENTO);
    const noSupplementsList = [
      deepGet(allProducts, "healthStudents.products_colectivo", ""),
      deepGet(allProducts, "healthResidents.products_colectivo", ""),
      deepGet(allProducts, "healthPremium.products_colectivo", ""),
    ];
    const hasSupplements = privilegeBtnSuplemento && !noSupplementsList.includes(colective);

    /* PREVENT FORBIDDEN ACCESS*/
    if (forbidden) {
      return <Redirect to="/403" />
    }

    return (
      <DetailClientsPoliciesContainer>
        <div className="detail-clients-policies-back">
          <GoBack text="Volver" onClick={() => this.props.history.push('/polizas-clientes')} />
        </div>

        <ErrorModalContainer
          className={`${serverError && `active`}`}
          active={serverError}>
          <div className="recover-modal">
            <div className="server-error">
              <p>Se ha producido un error. Inténtelo más tarde.</p>
            </div>
            <div className="button-error">
              <MainButton text="Aceptar" onClick={() => this.setState({ serverError: false })} />
            </div>

          </div>
        </ErrorModalContainer>

        {<div className="tab-container">
          <div className="tabs">
            <ul className="col-12 padding0">
              <li className={`col-2 ${(currentTab === 'datos-poliza') ? `tab-selected` : `tab-not-selected`}`}
                data-id="datos-poliza" onClick={this.changeTab.bind(this)}>Datos póliza</li>
              <li className={`col-2 ${(currentTab === 'datos-tomador') ? `tab-selected` : `tab-not-selected`}`}
                data-id="datos-tomador" onClick={this.changeTab.bind(this)}>Datos tomador</li>
              <li className={`col-2 ${(currentTab === 'datos-riesgo') ? `tab-selected` : `tab-not-selected`}`}
                data-id="datos-riesgo" onClick={this.changeTab.bind(this)}>Datos de riesgo</li>
              <li className={`col-2 ${(currentTab === 'recibos') ? `tab-selected` : `tab-not-selected`}`}
                data-id="recibos" onClick={this.changeTab.bind(this)}>Recibos</li>
              <li className={`col-2 ${(currentTab === 'tarjetas') ? `tab-selected` : `tab-not-selected`}`}
                data-id="tarjetas" onClick={this.changeTab.bind(this)}>Tarjetas</li>
            </ul>
          </div>
        </div>
        }
        {(currentTab !== undefined) ? this.handleTab() : ''}

        {hasSupplements && policyOrigin !== 'OCASO' && (
          <div className="floatButton">
            <Button onClick={() => this.generateSuplements()} text={'Generar suplemento'} />
          </div>
        )}


      </DetailClientsPoliciesContainer>
    );
  }

  openWPStatusModal () {
    this.setState({isWPStatusModalVisible: true})
  }

  getWPStatusRows (wpStatus: any[]) {
    let rows: any = [];
    
    wpStatus.forEach( wpStatusCommunication => {
      const newRow = {
        service: {
          text: wpStatusCommunication.Tipo_Servicio,
          type: "",
          key: "responsive",
        },
        state: {
          text: wpStatusCommunication.Situacion,
          type: "",
          key: "responsive",
        },
        description: {
          text: wpStatusCommunication.Descripcion,
          type: "",
          key: "responsive",
        },
        date: {
          text: wpStatusCommunication.Fecha,
          type: "",
          key: "responsive",
        }
      }
      rows.push(newRow);
    });

    return rows;
  }

  getTotalPricePolicy() {
    try {
      const { policyData } = this.state;

      if (policyData.length > 0 && policyData.some(row => row.prima_total_anualizada != null)) {
        const prima_total_anualizada_poliza = policyData.reduce((sum, row) => {
          const text = row.prima_total_anualizada ? row.prima_total_anualizada.trim() : "";
          const value = text ? Number(text) : NaN;
          return !isNaN(value) && value > 0 ? sum + value : sum;
        }, 0);

        return formatter.format(prima_total_anualizada_poliza);
      }
      return "-";
    } catch (error) {
      console.error(error);
      return ""; 
    }
  }

  handleTab() {
    const { mostrarModalTarjeta, datosTarjeta, currentTab, policyDataRows, takerDataRows, receiptDataRows, tarjetasDataRows, receiptsParams, riskParams, 
      noDataMessage, policyOrigin, showPrima, primaError, wpSignedStatus, wpSignedError, wpError, wpStatus, isWPStatusModalVisible } = this.state;
    let element;
    const hasRenewalLetter = deepGet(this.state, "policyData.0.hasRenewalLetter", false);
    const subramo = deepGet(this.state, "policyData.0.subramo", "") || "";
    const showRenewalLetter =
      hasRenewalLetter &&
      policyOrigin === "SENDA" &&
      (subramo.toLowerCase().includes("salud") || subramo.toLowerCase().includes("dental"));
    const takerDirection = takerDataRows.length > 0 && takerDataRows[0].direction.text ? takerDataRows[0].direction.text : '' 
    takerDataRows.length > 0 && takerDataRows[0].direction.text ? takerDataRows[0].direction.text : '';

    switch (currentTab) {
      case 'datos-poliza':
        element = (
          <div className="detail-clients-policies-item col-12">
            {primaError && (
              <Alert type="error">
                <p>{primaError}</p>
                <SimpleButton
                  text="Reintentar"
                  icon={images.IconRetry}
                  alt="icono reintentar"
                  onClick={() => this.getPolicy(true)}
                />
              </Alert>
            )}

            {isWPStatusModalVisible && wpStatus.length &&
              <WPStatusModal
                close={() => this.setState({ isWPStatusModalVisible: false })}
                wpStatus={this.getWPStatusRows(wpStatus)}
              />
            }

            <div className="colSin-30 padding10 bgWhite">
              <div className="inputBox filtersMargin">
                <input value={policyDataRows.length > 0 && policyDataRows[0].policyMediator.text ? policyDataRows[0].policyMediator.text : ''} type="text" readOnly />
                <label>MEDIADOR</label>
              </div>
              <div className="inputBox filtersMargin">
                <input value={policyDataRows.length > 0 && policyDataRows[0].policyNumber.text ? policyDataRows[0].policyNumber.text : ''} type="text" readOnly />
                <label>Nº DE PÓLIZA</label>
              </div>
              <div className="inputBox filtersMargin">
                <input value={policyDataRows.length > 0 && policyDataRows[0].policyGrupoNegocio.text ? policyDataRows[0].policyGrupoNegocio.text : ''} type="text" readOnly />
                <label>LINEA/GRUPO DE NEGOCIO</label>
              </div>
              <div className="inputBox filtersMargin">
                <input value={policyDataRows.length > 0 && policyDataRows[0].policyColective.text ? policyDataRows[0].policyColective.text : ''} type="text" readOnly />
                <label>COLECTIVO</label>
              </div>
            </div>

            <div className="colSin-40 padding10 bgWhite">
              <div className="colSin-50 rightPadding10">
                <div className="inputBox filtersMargin">
                  <input value={policyDataRows.length > 0 ? this._searchStatus(policyDataRows) : ''} type="text" readOnly />
                  <label>ESTADO</label>
                </div>
              </div>
              <div className="colSin-50">
                <div className="inputBox filtersMargin">
                  <input value={policyDataRows.length > 0 && policyDataRows[0].policyReleaseDate.text ? policyDataRows[0].policyReleaseDate.text : ''} type="text" readOnly />
                  <label>FECHA EMISIÓN</label>
                </div>
              </div>
              <div className="colSin-50 rightPadding10">
                <div className="inputBox filtersMargin">
                  <input value={policyDataRows.length > 0 && policyDataRows[0].policyInitialDate.text ? policyDataRows[0].policyInitialDate.text : ''} type="text" readOnly />
                  <label>FECHA EFECTO</label>
                </div>
              </div>
              <div className="colSin-50">
                <div className="inputBox filtersMargin">
                  <input value={policyDataRows.length > 0 && policyDataRows[0].policyFinishDate.text ? policyDataRows[0].policyFinishDate.text : ''} type="text" readOnly />
                  <label>FECHA VENCIMIENTO</label>
                </div>
              </div>
              <div className="colSin-50 rightPadding10">
                <div className="inputBox filtersMargin">
                  <input style={wpSignedError ? { color: 'red' } : {}} value={wpSignedStatus !== '' ? wpSignedStatus : '-'} type="text" readOnly />
                  <label>ESTADO FIRMA WP</label>
                </div>
              </div>
              <div className="colSin-50 rightPadding10">
                <div className="inputBox filtersMargin flex-no-wrap">
                  <input 
                    style={wpError ? { color: 'red' } : {}} 
                    value={wpStatus.length ? wpStatus[wpStatus.length - 1].Situacion : '-'} 
                    type="text" 
                    onClick={() => { (!wpError && !!wpStatus.length) && this.openWPStatusModal()}}
                    className={`${wpStatus.length ? "wp-status-input" : '' }`}
                    readOnly
                  />
                  <label>ESTADO WP</label>
                  {(!wpError && !!wpStatus.length) &&
                    <div className="wp-status-color-container" onClick={() => this.openWPStatusModal()}>
                      <div className="wp-status-color-circle" style={{backgroundColor: wpStatus.length && wpStatus[wpStatus.length - 1].Situacion === 'No enviado' ? '#e5e51a' : 'green' }}></div>
                    </div>
                  }
                </div>
              </div>

              <div className="colSin-50 rightPadding10">
                <div className="inputBox filtersMargin">
                  <input value={policyDataRows.length > 0 && policyDataRows[0].policyPaymentForm.text ? policyDataRows[0].policyPaymentForm.text : ''} type="text" readOnly />
                  <label>FORMA DE PAGO</label>
                </div>
              </div>

              <div className="colSin-50 rightPadding10">
                <div className="inputBox filtersMargin">
                  <input value={this.getTotalPricePolicy()} type="text" readOnly/>
                  <label>PRIMA TOTAL ANUALIZADA</label>
                </div>
              </div>

              {showPrima && !primaError && (
                <div className="colSin-50 rightPadding10">
                  <div className="inputBox filtersMargin">
                    <input
                      value={
                        policyDataRows.length > 0 &&
                          policyDataRows[0].policyPrimaTotal &&
                          policyDataRows[0].policyPrimaTotal.text
                          ? policyDataRows[0].policyPrimaTotal.text
                          : ""
                      }
                      type="text"
                      readOnly
                    />
                    <label>PRIMA DE RENOVACIÓN</label>
                  </div>
                </div>
              )}
            </div>

            {policyOrigin !== 'OCASO' &&
              <div className="colSin-30 padding10">
                <div className="bgWhite topPadding25">
                  <label>CONDICIONES PARTICULARES</label>
                  <div onClick={() => this.getPolicyDocuments()} className="button downloadFile horizontal topMargin5">VER DOCUMENTACIÓN</div>
                </div>
              </div>
            }

            {showRenewalLetter && (
              <div className="colSin-30 padding10">
                <div className="bgWhite topPadding25">
                  <label>CARTA DE RENOVACIÓN</label>
                  <div
                    className="button downloadFile horizontal topMargin5"
                    onClick={() => this.downloadRenewalLetter()}
                  >
                    VER DOCUMENTACIÓN
                  </div>
                </div>
              </div>
            )}

          </div>
        );
        break;

      case 'datos-tomador':
        element = (
          <div className="detail-clients-policies-item col-12">

            <div className="colSin-40 padding10">
              <div className="bgWhite height405">
                <div className="inputBox filtersMargin">
                  <input value={takerDataRows.length > 0 && takerDataRows[0].takerName.text ? takerDataRows[0].takerName.text : ''} type="text" readOnly />
                  <label>NOMBRE DEL TOMADOR</label>
                </div>
                <div className="inputBox filtersMargin">
                  <input value={takerDataRows.length > 0 && takerDataRows[0].policyNIF.text ? takerDataRows[0].policyNIF.text : ''} type="text" readOnly />
                  <label>DNI/NIE</label>
                </div>
                <div className="inputBox filtersMargin">
                  <input value={takerDataRows.length > 0 && takerDataRows[0].genre.text ? takerDataRows[0].genre.text : ''} type="text" readOnly />
                  <label>SEXO</label>
                </div>
                <div className="inputBox filtersMargin">
                  <input value={takerDataRows.length > 0 && takerDataRows[0].civil_state.text ? takerDataRows[0].civil_state.text : ''
                  } type="text" readOnly />
                  <label>ESTADO CIVIL</label>
                </div>
              </div>
            </div>

            <div className="colSin-40 padding10">
              <div className="bgWhite height355">
                <div className="inputBox textareaBox filtersMargin">
                  <textarea value={takerDataRows.length > 0 && takerDataRows[0].direction.text ? takerDataRows[0].direction.text : ''} readOnly rows={4} />
                  <label>DIRECCIÓN COMPLETA</label>
                </div>
                <div className="inputBox filtersMargin">
                  <input value={takerDataRows.length > 0 && takerDataRows[0].phone.text ? takerDataRows[0].phone.text : ''} type="text" readOnly />
                  <label>TELÉFONO</label>
                </div>
                <div className="inputBox filtersMargin">
                  <input value={takerDataRows.length > 0 && takerDataRows[0].mail.text ? takerDataRows[0].mail.text : ''} type="text" readOnly />
                  <label>EMAIL</label>
                </div>
              </div>
            </div>
          </div>);
        break;

      case 'datos-riesgo':
        element = (
          <div className="detail-clients-policies-item col-12">
            {primaError && (
              <Alert type="error">
                <p>{primaError}</p>
                <SimpleButton
                  text="Reintentar"
                  icon={images.IconRetry}
                  alt="icono reintentar"
                  onClick={() => this.getPolicy(true)}
                />
              </Alert>
            )}

            {(this.state.personDataRows && this.state.personDataRows.length > 0) ? this.checkPersons(riskParams) : this.checkPets(riskParams)}
            {this.state.personDataRows.length === 0 && noDataMessage}

          </div>);
        break;

      case 'recibos':
        element = (
          <div className="detail-clients-policies-item col-12">

            {receiptDataRows.length === 0 ? noDataMessage :
              (<>
                <div className="detail-clients-policies-item-content-table">
                  <MainTable
                    className="table topMargin15"
                    columns={receiptDataColumns}
                    rows={receiptDataRows}
                    keysRow={["numero_recibo", "estado_recibo", "colectivo", "fec_vencimiento_poliza", "fec_expedicion", "fec_cobertur_desde", "fec_cobertur_hasta", "imp_importe_total"]}
                    onOrder={(column: string, ascendent: boolean | undefined) => this.handleReceiptOrder(column, ascendent)}
                    defaultOrder={{ 'fec_expedicion': false }}
                    keysAlignRight={["imp_importe_total"]}
                  />
                </div>
                <div className="pendant-simulation-pagination">
                  <Pagination page={receiptsParams.page} limit={receiptsParams.totalPages} callback={(page) => this.setReceiptPage(page)} />
                </div>
              </>)}
          </div>);
        break;

      case 'tarjetas':
        element = (
          <div>
            {mostrarModalTarjeta &&
              <ModalTarjetas
                close={() => this.setState({ mostrarModalTarjeta: false, datosTarjeta: {} })}
                title={"Tarjetas"}
                datosTarjeta={datosTarjeta}
              />
            } 
            <div className="detail-clients-policies-item col-12">
              {tarjetasDataRows.length === 0 ? noDataMessage :
                (<>
                  <div className="detail-clients-policies-item-content-table">
                    <MainTable
                      className="table topMargin15"
                      columns={tarjetasDataColumns}
                      rows={tarjetasDataRows}
                      keysRow={["nif", "titular", 
                        // "numero_tarjeta",
                        "version", "fec_efecto", "fec_caducidad", "estado", "action"]}
                      onOrder={(column: string, ascendent: boolean | undefined) => this.handleReceiptOrder(column, ascendent)}
                      defaultOrder={{ 'fec_expedicion': false }}
                      keysAlignRight={["imp_importe_total"]}
                    />
                  </div>
                  <div className="pendant-simulation-pagination">
                    <Pagination page={receiptsParams.page} limit={receiptsParams.totalPages} callback={(page) => this.setReceiptPage(page)} />
                  </div>
                </>)}
            </div>
          </div>);
        break;
      default: break;
    }

    return element;
  }
  private _searchStatus(policyDataRows: IPolicyDataRow[]): string {
    return policyDataRows.find(row => row.status.text === STATUS.VIGENTE)
      ? STATUS.VIGENTE
      : STATUS.BAJA;
  }

  setReceiptPage = (page: number) => {
    const { receiptsParams } = this.state;
    receiptsParams.page = page;
    this.setState({ receiptsParams }, () => this.getReceipts(false));
  };

  setRiskPage = (page: number) => {
    const { riskParams } = this.state;
    riskParams.page = page;
    this.setState({ riskParams }, () => this.getRisk(true));
  };

  handleReceiptOrder = (column: string, ascendent: boolean | undefined) => {
    const { receiptsParams } = this.state;
    receiptsParams.order = column;
    receiptsParams.ascendent = ascendent;
    this.setState({ receiptsParams }, () => this.getReceipts(false))
  };

  handleRiskOrder = (column: string, ascendent: boolean | undefined) => {
    const { riskParams } = this.state;
    riskParams.order = column;
    riskParams.ascendent = ascendent;
    this.setState({ riskParams }, () => this.getRisk(true))
  };

  async changeTab(event: any): Promise<void> {
    let { currentTab, noDataMessage } = this.state;

    switch (event.currentTarget.dataset.id) {
      case 'datos-poliza':
        if (this.state.currentTab !== event.currentTarget.dataset.id) {
          this.getPolicy()
          currentTab = 'datos-poliza';
        }
        break;

      case 'datos-tomador':
        if (this.state.currentTab !== event.currentTarget.dataset.id) {
          this.getTaker()
          currentTab = 'datos-tomador';
        }
        break;

      case 'datos-riesgo':
        if (this.state.currentTab !== event.currentTarget.dataset.id) {
          noDataMessage = '';
          this.getRisk()
          currentTab = 'datos-riesgo';
        }
        break;

      case 'recibos':
        if (this.state.currentTab !== event.currentTarget.dataset.id) {
          this.state.receiptDataRows.length = 0;
          this.state.receiptsParams.page = 1;
          noDataMessage = '';
          this.getReceipts(true)
          currentTab = 'recibos';
        }
        break;
      case 'tarjetas':
        if (this.state.currentTab !== event.currentTarget.dataset.id) {
          noDataMessage = '';
          await this.getRisk()
          await this.getTarjetas()
          currentTab = 'tarjetas';
        }
        break;
      default:
        break;
    }

    this.setState({ currentTab, noDataMessage });
  }

  checkPersons(riskParams: ITableConfig) {
    const { showPrima, primaError } = this.state;
    const keysRow = ["fec_efecto_alta", "fec_efecto_baja", "nom_asegurado", "nif_asegurado", "fec_nacimiento", "sexo", "direccion", 'prima_anualizada'];
    const columns = [...personDataColumns];

    if (showPrima && !primaError) {
      keysRow.push('prima');
      columns.push({
        text: "Prima de renovación",
        filter: false,
        ascendent: true,
        key: "",
      })
    }

    return <div className="data-taker-container">
      <div className="data-taker-name">
        <h6>PERSONAS</h6>
      </div>
      <div className="detail-clients-policies-item-content-table">
        <MainTable
          className="table"
          columns={columns}
          rows={this.state.personDataRows}
          keysRow={keysRow}
          onOrder={(column: string, ascendent: boolean | undefined) => this.handleRiskOrder(column, ascendent)}
        />
      </div>
      <div className="pendant-simulation-pagination">
        <Pagination page={riskParams.page} limit={riskParams.totalPages} callback={(page) => this.setRiskPage(page)} />
      </div>
    </div>
  }

  checkPets(riskParams: ITableConfig) {
    if (this.state.petDataRows && this.state.petDataRows.length > 0)
      return <div className="data-taker-container">
        <div className="data-taker-name">
          <h6>MASCOTAS</h6>
        </div>
        <div className="detail-clients-policies-item-content-table">
          <MainTable
            className="table"
            columns={petDataColumns}
            rows={this.state.petDataRows}
            keysRow={["fec_efecto_alta", "fec_efecto_baja", "nom_mascota", "nom_propietario", "chip", "fec_nacimiento", "tipo_mascota", 'prima_anualizada']}
            onOrder={(column: string, ascendent: boolean | undefined) => this.handleRiskOrder(column, ascendent)}
          />
        </div>
        <div className="pendant-simulation-pagination">
          <Pagination page={riskParams.page} limit={riskParams.totalPages} callback={(page) => this.setReceiptPage(page)} />
        </div>
      </div>
  }
}

export default withGeneral(withDynamicProducts(withRouter(DetailClientsPoliciesLayout)));
